// extracted by mini-css-extract-plugin
export default {"wrapper":"AnimatedScale__wrapper--3Jkvs"};